const GOVT_CONTRIBUTION_RATE = 0.5
const GOVT_CONTRIBUTION_CAP = 521.43
const EMPLOYER_MATCH_RATE = 0.03

export function projectBalance({ balance, salary, contributionRate, fees, years }) {
  const annualContribution = salary * (contributionRate / 100)
  const annualEmployer = salary * EMPLOYER_MATCH_RATE
  const annualGovt = Math.min(annualContribution * GOVT_CONTRIBUTION_RATE, GOVT_CONTRIBUTION_CAP)
  const totalAnnualIn = annualContribution + annualEmployer + annualGovt
  const feeRate = fees / 100

  let current = balance
  const balances = [current]

  for (let y = 1; y <= years; y++) {
    current = current + totalAnnualIn
    current = current * (1 - feeRate)
    balances.push(Math.round(current * 100) / 100)
  }

  return balances
}

export function calculateResults(funds, { balance, salary, contributionRate, years }) {
  return funds.map(fund => {
    const balances = projectBalance({
      balance, salary, contributionRate,
      fees: fund.fees, years
    })
    const finalBalance = balances[balances.length - 1]
    const totalIn = balance + (salary * (contributionRate / 100) +
      salary * EMPLOYER_MATCH_RATE +
      Math.min(salary * (contributionRate / 100) * GOVT_CONTRIBUTION_RATE, GOVT_CONTRIBUTION_CAP)
    ) * years
    const totalFeesPaid = totalIn - finalBalance

    return {
      name: fund.name,
      fees: fund.fees,
      totalFeesPaid: Math.max(0, totalFeesPaid),
      finalBalance,
      balances
    }
  })
}

export function formatCurrency(value) {
  return "$" + Number(value).toLocaleString("en-NZ", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}
